var _circle, _rect, _path, _path2, _path3, _ellipse, _ellipse2, _ellipse3, _circle2, _mask, _g, _path4, _rect2, _mask2, _g2, _path5, _rect3, _rect4, _path6, _path7, _path8, _rect5, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFormPublisherLogoCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 48,
    fill: "#F6F5FA"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17.28,
    y: 33.249,
    width: 60.4097,
    height: 35.122,
    rx: 17.561,
    fill: "#6246E4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.5791 21.0597C64.4496 21.2763 65.0459 22.0672 65.0459 22.9642V34.6539H29.9239V22.9642C29.9239 22.0672 30.5202 21.2763 31.3907 21.0597C36.1522 19.8753 41.6412 19.2002 47.4849 19.2002C53.3285 19.2002 58.8176 19.8753 63.5791 21.0597Z",
    fill: "#6246E4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.8843 36.9204L69.9513 29.9775L70.7845 30.1056L69.7174 37.0485L68.8843 36.9204Z",
    fill: "#6246E4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.5648 37.4803L74.0205 34.9453L74.5191 35.625L71.0634 38.16L70.5648 37.4803Z",
    fill: "#6246E4"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 70.4746,
    cy: 29.3473,
    rx: 2.10732,
    ry: 2.10732,
    transform: "rotate(8.73736 70.4746 29.3473)",
    fill: "#6246E4"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 75.3887,
    cy: 34.3668,
    rx: 2.10732,
    ry: 2.10732,
    transform: "rotate(8.73735 75.3887 34.3668)",
    fill: "#6246E4"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.9357,
    cy: 62.7799,
    rx: 1.40488,
    ry: 1.40488,
    fill: "#4226C2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 66.0506,
    cy: 62.774,
    r: 1.40488,
    fill: "#4226C2"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 36,
    width: 55,
    height: 30
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.841 36.0586C26.6941 36.0586 20.0898 42.6629 20.0898 50.8098C20.0898 58.9567 26.6941 65.561 34.841 65.561H60.1288C68.2757 65.561 74.88 58.9567 74.88 50.8098C74.88 42.6629 68.2757 36.0586 60.1288 36.0586H34.841ZM34.841 38.8683C28.2459 38.8683 22.8995 44.2147 22.8995 50.8098C22.8995 57.4049 28.2459 62.7513 34.841 62.7513H60.1288C66.7239 62.7513 72.0703 57.4049 72.0703 50.8098C72.0703 44.2147 66.7239 38.8683 60.1288 38.8683H34.841Z",
    fill: "#4226C2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.6542 61.211L65.2538 61.1299L67.5553 65.67L27.5604 65.8307L29.6542 61.211Z",
    fill: "#4226C2"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8312 74.8273C60.8312 75.3116 60.4844 75.7271 60.0065 75.8064C56.1451 76.4467 51.917 76.7998 47.4849 76.7998C43.0528 76.7998 38.8247 76.4467 34.9633 75.8064C34.4854 75.7271 34.1385 75.3116 34.1385 74.8273V62.751H60.8312V74.8273Z",
    fill: "url(#paint0_linear)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 34.1385,
    y: 62.751,
    width: 26.6927,
    height: 1.43298,
    fill: "black"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 33,
    width: 61,
    height: 36
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60.4097,
    height: 35.122,
    rx: 17.561,
    transform: "matrix(1 0 0 -1 17.28 68.3711)",
    fill: "#6246E4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.1142 33.2496C27.1142 36.3532 29.6301 38.8691 32.7337 38.8691H62.2361C65.3397 38.8691 67.8556 36.3532 67.8556 33.2496H27.1142Z",
    fill: "#4226C2"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1142 50.8098C27.1142 46.5424 30.5736 43.083 34.841 43.083H60.1288C64.3962 43.083 67.8556 46.5424 67.8556 50.8098C67.8556 55.0772 64.3962 58.5367 60.1288 58.5367H34.841C30.5736 58.5367 27.1142 55.0772 27.1142 50.8098Z",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 36.9483,
    y: 45.8926,
    width: 4.21463,
    height: 7.02439,
    rx: 2.10732,
    fill: "#6246E4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 53.8068,
    y: 45.8926,
    width: 4.21463,
    height: 7.02439,
    rx: 2.10732,
    fill: "#6246E4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5434 23.7813C59.5434 23.3043 59.2068 22.8927 58.7376 22.8068C55.2831 22.1739 51.5038 21.8252 47.5434 21.8252C43.583 21.8252 39.8038 22.1739 36.3493 22.8068C35.88 22.8927 35.5434 23.3043 35.5434 23.7813V35.874H59.5434V23.7813Z",
    fill: "url(#paint1_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M59.52 25.0863C55.8507 24.3879 51.7907 24 47.52 24C43.2494 24 39.1893 24.3879 35.52 25.0863V37.44H59.52V25.0863Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8312 27.7518C60.8312 27.2674 60.4844 26.8519 60.0065 26.7727C56.1451 26.1324 51.917 25.7793 47.4849 25.7793C43.0528 25.7793 38.8247 26.1324 34.9633 26.7727C34.4854 26.8519 34.1385 27.2674 34.1385 27.7518V38.8681H60.8312V27.7518Z",
    fill: "url(#paint2_linear)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 34.1385,
    y: 37.4639,
    width: 26.6927,
    height: 1.43298,
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 47.4849,
    y1: 62.751,
    x2: 47.4849,
    y2: 76.7998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCBC14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 47.5434,
    y1: 21.8252,
    x2: 47.5434,
    y2: 36.9044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCBC14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 47.4849,
    y1: 25.7793,
    x2: 47.4849,
    y2: 39.8281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCBC14"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormPublisherLogoCircle);
export default __webpack_public_path__ + "static/media/form-publisher-logo-circle.389a1585.svg";
export { ForwardRef as ReactComponent };